import { useMutation } from '@tanstack/react-query'
import { NswContractStage, QldContractStage } from '@urbanx/agx-ui-components'
import { PerformContractAction } from 'services'
import useSelectedContract from './useSelectedContract'
import useSelectedCampaign from './useSelectedCampaign'
import { AuthContext } from '@urbanx/agx.auth.client'
import { useContext } from 'react'
import { ContractActionRequestContractAction } from '@urbanx/agx.campaigns.client'

const useSelectedContractStage = (): {
  contractStage?: QldContractStage | NswContractStage
  performContractAction: (action: ContractActionRequestContractAction) => void
} => {
  const { getAuthToken } = useContext(AuthContext)
  const { campaign } = useSelectedCampaign()
  const { contract } = useSelectedContract()

  const { mutate: performContractActionValue } = useMutation({
    mutationFn: PerformContractAction,
  })

  const performContractAction = (action: ContractActionRequestContractAction) => {
    if (!campaign?.campaignId || !contract?.contractId) return

    performContractActionValue({
      getAuthToken: getAuthToken,
      campaignId: campaign.campaignId,
      contractId: contract.contractId,
      contractStageAction: action,
    })
  }

  return {
    contractStage: contract?.contractStage,
    performContractAction: performContractAction,
  }
}

export default useSelectedContractStage
